import { render, staticRenderFns } from "./bottom-tab.vue?vue&type=template&id=ef99eda4&scoped=true&"
import script from "./bottom-tab.vue?vue&type=script&lang=ts&"
export * from "./bottom-tab.vue?vue&type=script&lang=ts&"
import style0 from "./bottom-tab.vue?vue&type=style&index=0&id=ef99eda4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef99eda4",
  null
  
)

export default component.exports